// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2PO-a","overflowing":"ReadFullNote_overflowing__2CptS"};